import styles from "./reward.module.css";
import { useCallback, useContext, useEffect, useState } from "react";
import { UserContext } from "../../context/userContext";
import { apiConfig } from "../../commonFunction/apiconfig";
import axios from "axios";
import { toast } from "react-toastify";


export default function RewardIncome() {
  const { userToken } = useContext(UserContext);
  const [data, setData] = useState([]);
  const [rewardValue, setRewardValue] = useState({});

  const getRewardData = useCallback(async () => {
    if (userToken === "") return;
    try {
      const headers = {
        token: userToken,
      };
      const res = await axios.get(
        `${apiConfig.getFeeReward}`,
        { headers }
      );
      setData(res?.data?.result || []);
    } catch (error) {
      console.log(error);
      setData([]);
    }
  }, [userToken]);

  useEffect(() => {
    getRewardData();
  }, [getRewardData]);

  const handleRadioButtonClick = (id, currentStatus) => {
    const updatedData = data.map((item) =>
      item._id === id ? { ...item, status: !currentStatus } : item
    );
    setData(updatedData);
  };

  const updateRewardHandle = async (id,type) => {
    if (!userToken) return;

    const currentRewardValue = rewardValue[id] !== undefined
      ? rewardValue[id]
      : data.find(item => item._id === id)?.percentage || 0;

    console.log(data._id,"iddddd");

      const currentStatus = data.find(item => item._id === id)?.status;
    console.log(currentStatus,"currentStatus");

    const baseData = {
      id: id,
      percentage: currentRewardValue,
      status: currentStatus,
    };

    let requestData = baseData;

    if (type === 'directRefferalIncome') {
      requestData = {
        ...baseData,
        levelObj: {
          level1: Number(currentRewardValue),
          level2: 0,
          level3: 0,
          level4: 0,
          level5: 0,
          level6: 0,
          level7: 0,
          level8: 0,
          level9: 0,
          level10: 0
        }
      };
    }

    try {
      const headers = { token: userToken };
      const res = await axios.post(`${apiConfig.updateFeeReward}`, requestData, { headers });

      if (res.data.statusCode === 200) {
        toast.success('Updated successfully');
        getRewardData();
      } else {
        toast.error('Failed to update');
      }
    } catch (error) {
      console.error('Error updating reward:', error);
      toast.error('An error occurred while updating');
    }
  };

  return (
    <div className={styles?.userContainer}>
      <h1 className={styles?.userContainerHeading}>Fees Management</h1>

      <div className={styles.gridContainer}>
        {data.map((items) => {
          return (
            <div className={styles.topBox} key={items._id}>
              <div className={styles.dashboardContainer}>

                <p>{items.name}</p>
                <div
                  onClick={() => handleRadioButtonClick(items._id, items.status)}
                  style={{
                    display: 'inline-block',
                    padding: '10px 20px',
                    backgroundColor: !items.status ? 'green' : 'red',
                    color: 'white',
                    borderRadius: '20px',
                    cursor: 'pointer',
                    textAlign: 'center',
                    fontSize: '16px',
                  }}
                >
                  {items.status ? 'Disable' : 'Enable'}
                </div>
              </div>
              <div style={{ marginTop: "1rem", padding: "10px 14px" }}>
                <p style={{ textAlign: "center" }}>{items.status === true ? "Active" : "Inactive"}</p>

                <p style={{ textAlign: "center", padding: "10px 0px" }}>Update Setting</p>
                <div className={styles.inputBox}>
                  <span>Enter the Percentage</span>
                  <div className={styles.inputBoxChild}>
                    <input
                      type="number"
                      className={styles.inputField}
                      value={rewardValue[items._id] !== undefined ? rewardValue[items._id] : items.percentage || ''}
                      onChange={(e) => {
                        setRewardValue((prev) => ({ ...prev, [items._id]: e.target.value }));
                      }}
                      disabled={!items.status}
                    />
                    <button
                      className={styles.downloadBtn}
                      onClick={() => updateRewardHandle(items._id, items.type)}
                    >
                      SAVE
                    </button>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

